module.exports = __webpack_public_path__ + "media/images/flags/DO-68e249944b890460f42cbdf65a312a6c.svg";